import liveEventTpl from "templates/__liveEvent.tpl";
import noDataTpl from "templates/__noData.tpl";
import defaultTpl from "templates/__gridView.tpl";
import Breakpoints from "helpers/breakpoints";
import "carousels/helpers/ellipsify";

export default function (customOptions = {}) {

    let templates = {
        liveEventTpl: liveEventTpl,
        noDataTpl: noDataTpl,
        defaultTpl: defaultTpl
    };
    let template = customOptions.useTemplate ? templates[customOptions.useTemplate] : defaultTpl;
    let noDataMessage = customOptions.options.noDataMessage ? customOptions.options.noDataMessage : 'No Live Events Available.';
    let noResizeListener = customOptions.options.noResizeListener ? customOptions.options.noResizeListener : false;


    let parentContainer = customOptions.parentContainer ? customOptions.parentContainer : $('#latest-episodes');
    let container = parentContainer.find('.grid-view-container');
    let btnLoadMore = parentContainer.find('.js-load-more');
    let btnLoadMoreText = btnLoadMore.find('.button__text');
    let btnLoadMoreCopy = btnLoadMoreText.text();
    let svgLoader = parentContainer.find('.grid-view-svg-loader');
    let rowHeaderTitle = $(parentContainer).find('h2').text();
    let timeout = 300;
    let b = new Breakpoints();
    let currentBreakpoint = b.getCurrentBreakpointName();
    let currentLiveEventsPage = 0;
    let isFirstLoad = true;
    let hasResized = false;
    let list = [];
    let currentIdx = 0;
    let currentArticleHeight = 0;
    let currentParams = null;
    let filters = null;
    let total = null;

    let loadSizes = {
        'desktopWide': 18,
        'desktop': 10,
        'tabletLandscape': 8,
        'tabletPortrait': 6,
        'mobileLandscape': 4,
        'mobilePortrait': 4
    };


    let displayPerRowByBreakpoint = {
        mobilePortrait: 1,
        mobileLandscape: 2,
        tabletPortrait: 3,
        tabletLandscape: 4,
        desktop: 5,
        desktopWide: 6
    };


    let rowsByBreakpoint = {
        mobilePortrait: 4,
        mobileLandscape: 2,
        tabletPortrait: 2,
        tabletLandscape: 2,
        desktop: 2,
        desktopWide: 2
    };

    let toggleSvgLoader = function () {
        if (!isFirstLoad) {
            if (isLoading()) {
                btnLoadMore.find('svg').remove();
                btnLoadMoreText.text(btnLoadMoreCopy);
            } else {

                let svg = svgLoader.clone().css({
                    display: 'block'
                });
                btnLoadMore.append(svg);

                // clear text & prevents page jank
                btnLoadMoreText.html('&nbsp;');
            }
        }
    };

    let boot = function () {
        if ($(".js-load-more")[0]) {
            currentIdx = getLoadSize() > 12 ? 11 : getLoadSize() - 1;
            while (container.find('article.grid-view-item').length > loadSizes[b.getCurrentBreakpointName()]) {
                let articles = container.find('article.grid-view-item');
                $(articles[articles.length - 1]).remove();
            }
            // set local total & hide Load More if all videos listed
            total = container.data('total');
            //hideLoadMoreIfAllLoaded();
        }

    };

    let __killDropdownAnimHack = function () {
        let hoverMount = parentContainer.find('.js-dropdown').find('li.pv-h');
        hoverMount.addClass('pv-h-disable');
    };

    let isLoading = function () {
        return btnLoadMore.has('svg').length > 0;
    };

    let getRowsByBreakpoint = function () {
        return rowsByBreakpoint[b.getCurrentBreakpointName()];
    };

    let getPerRow = function () {
        return displayPerRowByBreakpoint[b.getCurrentBreakpointName()];
    };

    //getLoadSize is used to know how many to put into the dom
    let getLoadSize = function () {
        if ($(".js-load-more")[0]) {
            return loadSizes[b.getCurrentBreakpointName()];
        } else {
            return 50;
        }
    };

    //getLimitSize is used to get how many to retrieve from api
    let getLimitSize = function () {
        if ($(".js-load-more")[0]) {
            return loadSizes[b.getCurrentBreakpointName()];
        } else {
            return 50;
        }
    };


    let getLiveEvents = function (callback) {

        toggleSvgLoader();

        let limit = getLimitSize();
        let endpoint = buildEndpoint({
            page: currentLiveEventsPage,

            // clips grid xhr request uses these params
            offset: currentLiveEventsPage * limit,
            limit: limit
        });

        let timezone_offset_minutes = new Date().getTimezoneOffset();
        timezone_offset_minutes = timezone_offset_minutes === 0 ? 0 : -timezone_offset_minutes;

        if (!isFirstLoad && limit >= total) {
            loadListFromIndex(currentIdx + 1, total, true);
            toggleSvgLoader();
        } else {
            $.ajax({
                type: 'POST',
                url: endpoint,
                data: {
                    'timeZoneOffset': timezone_offset_minutes
                },
                dataType: 'json',
                success: function (resp) {
                    toggleSvgLoader();
                    if (total === null) {
                        total = resp.result.total;
                    }
                    appendList(resp);
                    if (callback) {
                        callback();
                    } else {
                        handleSuccess(resp);
                    }
                }
            });
        }

    };

    let focusFirstLoadedItem = function (startOfBatchIndex) {
        let link = container.find('article:eq(' + (startOfBatchIndex) +') a:eq(0)');
        if (link.length > 0) {
            $(link).focus()
        }
    };

    let buildEndpoint = function (merge) {

        let params = $.extend(currentParams, merge);

        if (currentParams === null) {
            // default params
            currentParams = {
                slug: parentContainer.data('slug'),
                page: currentLiveEventsPage,
                size: getLimitSize(),
                excludeShow: 0
            };

            params = $.extend(currentParams,
                customOptions.options.params,
                merge);
        }

        currentParams = params;

        let endpoint = customOptions.options.endPoint;
        for (let property in params) {
            if (params.hasOwnProperty(property)) {
                endpoint = endpoint.replace('{' + property + '}', params[property]);
            }
        }

        return endpoint;
    };

    let appendList = function (resp) {
        if (resp) {
            resp.result.data.forEach((obj) => {
                list.push(obj);
            });
        }
    };

    let handleSuccess = function () {
        if (isFirstLoad) {
            handleFirstLoad();
        } else {
            handleAnotherLoad();
        }

        localizeEventTimes();
    };

    let localizeEventTimes = function () {
        $('.event-timestamp').each(function(index) {
            let eventObj = $(this).closest('.air-time-container').find('.event-time');
            if (eventObj.text() === '') {
                let localizedTimeObj = new Date(parseInt($(this).val()));
                let localizedTimeStr = formatEventTime(localizedTimeObj);
                eventObj.text(localizedTimeStr);
            }
        });
    }

    let formatEventTime = function (localizedTimeObj) {
        let options = {
            month: 'short', day: 'numeric', year: 'numeric',
            hour: 'numeric', minute: 'numeric', hour12: true
        }
        let localizedTime = insertAtSign(new Intl.DateTimeFormat('en-US', options).format(localizedTimeObj));
        localizedTime = localizedTime.replace(' AM', 'am');
        localizedTime = localizedTime.replace(' PM', 'pm');
        return localizedTime;
    }

    let insertAtSign = function (localizedTime) {
        var i = 0;
        return localizedTime.replace(/,/g, function(match) {
            i+=1;
            if(i===2) return ' @ ';
            return match;
        });
    }

    let handleFirstLoad = function () {
        removeAll();
        loadListFromIndex(0, null, false);
        parentContainer.show();
    };

    let removeAll = function () {
        container.find('article.grid-view-item').remove();
    };

    let handleAnotherLoad = function () {
        let startOfNewBatch = currentIdx + 1;
        loadListFromIndex(currentIdx + 1, null, true);
        focusFirstLoadedItem(startOfNewBatch)
    };

    let handleResize = function () {
        hasResized = true;
        let resizedBreakpoint = b.getCurrentBreakpointName();
        if (currentBreakpoint !== resizedBreakpoint) {
            currentBreakpoint = resizedBreakpoint;
            if (isFirstLoad) {
                handleFirstLoad();
            } else {
                reloadAll();
            }
            hideLoadMoreIfAllLoaded();
        }

        localizeEventTimes();
    };

    let setProgressBarAlreadyRendered = function () {
        list.forEach((item, idx) => {
            if (!item.hasRendered) {
                item.hasRendered = true;
            }
        });
    };

    let reloadAll = function () {
        removeAll();
        loadListFromIndex(0, list.length, false);
    };

    let loadListFromIndex = function (from, to, doAnimation) {

        doAnimation = doAnimation === true;

        // fill dom
        let opacity = doAnimation === true ? 0 : 1;
        let max = to ? to : from + getLoadSize();

        if (list.length > 0) {
            for (let i = from; i < max && i < total; i++) {
                if (typeof list[i] !== 'undefined') {
                    currentIdx = i;
                    container.append(
                        $(template(list[i])).css({
                            opacity: opacity
                        })
                    );
                }
            }
        } else {
            container.append(
                $(templates.noDataTpl()).css({
                    opacity: opacity
                }).text(noDataMessage)
            );
        }

        if (CBS.Registry.lazyImage) {
            setTimeout(() => {
                CBS.Registry.lazyImage.revalidate();
            }, 200);
        }

        // fill holes if necessary

        let totalArticles = container.find('article.grid-view-item').length;
        let needsMore = totalArticles % getPerRow() !== 0 && totalArticles < total;

        if (needsMore) {
            handleNeedsMore();
        } else {
            if (doAnimation) {
                animateContainer();
            }
            container.ellipsify();
            // TODO: consider deleting if not needed
            hideLoadMoreIfAllLoaded();
        }

    };

    let animateContainer = function () {

        let _getGap = function () {

            let gap;

            // chrome
            if (!gap) {
                gap = container.css('gap');
                if (gap) {
                    gap = parseInt(gap.split(' ')[0]);
                }
            }

            // firefox
            if (!gap) {
                gap = container.css('row-gap');
                if (gap) {
                    gap = gap.replace('px', '');
                }
            }

            // safari
            if (!gap) {
                gap = container.css('grid-gap');
                if (gap) {
                    gap = parseInt(gap.replace('/ ', ''));
                }
            }

            // no gap found
            if (!gap) {
                gap = 0;
            }

            return gap;

        };

        // prep to animate container
        container.css({
            height: container.height()
        });

        currentArticleHeight = 0;
        let articles = container.find('article');
        articles.each(() => {
            let h = $(this).height();
            if (h > currentArticleHeight) {
                currentArticleHeight = h;
            }
        });

        let rows = getRowsByBreakpoint();
        let increase = (currentArticleHeight * rows) + _getGap();

        // animate grid container
        container.animate({
            height: container.height() + increase
        }, 300, () => {

            // set grid back to auto to adjust (this is in case there's only 1 line of copy for the title across row 1 OR 2, so there's proper spacing below grid container)
            container.css({
                height: 'auto'
            });

            // fade in grid items
            container.find('article').delay(300).animate({ //
                opacity: 1
            }, 300, () => {

                // animate Load More button
                hideLoadMoreIfAllLoaded();

            });

        });

    };

    let handleNeedsMore = function () {
        let currentLiveEventsCount = container.find('article.grid-view-item').length;
        let perRow = getPerRow();
        let remainder = currentLiveEventsCount % getPerRow();
        let numMore = perRow - remainder;

        if (numMore > 0) {

            let from = currentIdx + 1;
            let to = currentIdx + numMore + 1;
            let f = function () {
                // was false, testing smoothness
                loadListFromIndex(from, to, true);
            };

            if (currentLiveEventsCount + numMore <= list.length) {
                f();
            } else {
                currentLiveEventsPage++;
                getLiveEvents(f);
            }
        }

    };

    let hideLoadMoreIfAllLoaded = function () {
        // hide load more button when total episodes are displayed
        let l = container.find('article').length;
        if (container.find('article').length === total && total !== 0) {
            btnLoadMore.parent().addClass('load-more-container-hidden').removeClass('load-more-container-show');
        } else {
            btnLoadMore.parent().removeClass('load-more-container-hidden').addClass('load-more-container-show');
        }
    };

    let trackingLoadMoreBtn = function () {
        try {
            om.trackClick({
                item: btnLoadMore.attr('aa-link')
            });
        } catch (e) {
        }
    };

    if (parentContainer.length > 0) {

        $(document).ready(function () {

            getLiveEvents();

            btnLoadMore.on('click', (e) => {
                e.preventDefault();
                isFirstLoad = false;
                if (!isLoading()) {
                    currentLiveEventsPage++;
                    getLiveEvents();
                    trackingLoadMoreBtn();
                }
            });
            if (!noResizeListener) {
                window.addEventListener('resize', handleResize);
            }

        });

        boot();
    }

}
